import { useGetDepartmentSummary } from "../../../api/admin/department";
import { ApiDepartmentSummary } from "../../../models/api/admin/department";
import HeadlessGenericDropdown, {
    DropdownItem,
} from "../HeadlessGenericDropdown";

export type DepartmentDropdownProps = {
    companyId?: string;
    currentDepartment?: ApiDepartmentSummary | null;
    handleDepartmentChange: (department: ApiDepartmentSummary | null) => void;
    showLabel?: boolean;
};

const DepartmentDropdown: React.FC<DepartmentDropdownProps> = ({
    companyId,
    currentDepartment,
    handleDepartmentChange,
    showLabel,
}) => {
    const {
        departmentSummary,
        departmentSummaryError,
        isLoadingDepartmentSummary,
    } = useGetDepartmentSummary(companyId);

    const departmentsList = departmentSummary?.items;
    const departmentDropdownItems =
        departmentsList &&
        departmentsList.map((department) => ({
            item: department.departmentName,
            id: department.departmentId,
        }));
    const selectedItem: DropdownItem<string> = {
        item: currentDepartment?.departmentName,
        id: currentDepartment?.departmentId,
    };

    const handleItemSelect = (item: DropdownItem | null) => {
        const departmentFromId: ApiDepartmentSummary | undefined =
            departmentsList?.find(
                (department) => department.departmentId === item?.id
            );
        if (departmentFromId) handleDepartmentChange(departmentFromId);
    };

    return (
        <div>
            <HeadlessGenericDropdown
                dropdownPlaceholder="All departments"
                noItemsMessage="No departments found"
                dropdownData={departmentDropdownItems}
                selectedItem={selectedItem}
                handleItemChange={handleItemSelect}
                error={departmentSummaryError}
                isLoading={isLoadingDepartmentSummary}
                label={showLabel ? "Department" : undefined}
            />
        </div>
    );
};

export default DepartmentDropdown;
